module.exports = __webpack_public_path__ + "img/smzfzd.732aa656.png";